export default __webpack_public_path__ + "c3a6f43aff60421499762b378308f956.png";